/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useContext } from 'react'
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { signInWithRedirect } from 'aws-amplify/auth';
import { getStoreAuth } from '../services/authService';
import UserContext from '../context/UserContext';
import FeedbackContext from '../context/FeedbackContext';

const { REACT_APP_SAFETYCHECK_URL }= process.env;

const Login = ({history}) => {
  const { isLoggedIn } = useContext(UserContext);
  const { isLoading, setIsLoading } = useContext(FeedbackContext);

  useEffect(() => {
    let referer = document.referrer;
    if (referer === `https://${REACT_APP_SAFETYCHECK_URL}/home` && !isLoggedIn){
      // Clean up the referrer document property so it let's you log out in instore-auth
      Object.defineProperty(document, "referrer", {get : () => "" });
      login();
    }
  });

  useEffect( () => {
    if (isLoggedIn){
      history.push('./home')
    }
  },[isLoggedIn])

  const login = async () => {
    try {
      setIsLoading(true);
      const instoreAuthUsed = !!process.env.REACT_APP_BASE_INSTORE_API_URI;
      let storeAuth;
      if (instoreAuthUsed){
        storeAuth = await getStoreAuth();
      }
      if(!storeAuth || storeAuth === "not in store"){
        console.log(storeAuth, 'switching to Okta');
        signInWithRedirect({ provider: { custom: 'Okta'}});
      } else {
        Hub.dispatch('storeAuth', {event: 'signIn', data: storeAuth} )
      }
    } catch(error){
      console.log(error)
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      {!isLoading &&
        <button type="button" className="login-button" onClick={login}>
          Login 
        </button>
      }
    </div>
  )
}

Login.propTypes = {
  history: ReactRouterPropTypes.history
}

export default withRouter(Login)

